import React from 'react';

function Arrow({ dir }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5" aria-hidden="true">
      <path d={dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'} />
    </svg>
  );
}

/** A megjelenő oldalszámok: az első, az utolsó és a mostani ±1; a hézag helyén „…”. */
function pageList(page, total) {
  const keep = new Set([1, total, page - 1, page, page + 1].filter(p => p >= 1 && p <= total));
  const sorted = [...keep].sort((a, b) => a - b);
  const out = [];
  sorted.forEach((p, i) => {
    if (i && p - sorted[i - 1] > 1) out.push('gap-' + p);
    out.push(p);
  });
  return out;
}

const CELL = 'min-w-[34px] h-[34px] px-2 inline-grid place-items-center rounded-lg font-mono text-[13px] font-medium transition-colors duration-150';

/**
 * Lapozó — a sablon `.pagenums`-a (2026-10-04): számozott négyzetek, a mostani
 * kiemelve, két szélén nyíl. A `total` darabszám halványan a végén.
 */
export default function Pagination({ page, totalPages, total, label = 'entries', onPage, className = '' }) {
  if (totalPages <= 1) return null;

  return (
    <nav aria-label="Pages" className={`flex flex-wrap items-center justify-center gap-1 ${className}`}>
      <button type="button" onClick={() => onPage(Math.max(1, page - 1))} disabled={page === 1}
              aria-label="Previous page"
              className={`${CELL} border border-line text-gray-500 hover:text-gray-50 disabled:opacity-35 disabled:hover:text-gray-500`}>
        <Arrow dir="left" />
      </button>

      {pageList(page, totalPages).map(p => (
        typeof p === 'string' ? (
          <span key={p} className={`${CELL} text-gray-600`} aria-hidden="true">…</span>
        ) : (
          <button key={p} type="button" onClick={() => onPage(p)} aria-current={p === page ? 'page' : undefined}
                  className={`${CELL} border ${
                    p === page ? 'bg-gray-800 border-line-strong text-gray-50' : 'border-line text-gray-500 hover:text-gray-50'
                  }`}>
            {p}
          </button>
        )
      ))}

      <button type="button" onClick={() => onPage(Math.min(totalPages, page + 1))} disabled={page === totalPages}
              aria-label="Next page"
              className={`${CELL} border border-line text-gray-500 hover:text-gray-50 disabled:opacity-35 disabled:hover:text-gray-500`}>
        <Arrow dir="right" />
      </button>

      {total != null && (
        <span className="ml-2 font-mono text-xs text-gray-600">{total} {label}</span>
      )}
    </nav>
  );
}
